import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ModalController } from '@ionic/angular';
import { AuditTrailService } from 'src/app/audit-trail/audit-trail.service';
import { ModerationService } from 'src/app/services/moderation.service';

@Component({
  selector: 'app-secure-push-ml-modal',
  templateUrl: './push-ml-modal.component.html',
  styleUrls: ['./push-ml-modal.component.scss']
})
export class PushMlModalComponent implements OnInit {
  isSubmitDisabled: boolean = false;
  originalResponse: any[] = [];
  documents: any[] = [];
  pan: string;
  mlPendingDocuments: string;
  selectedRegId: number;

  constructor(private modalCtrl: ModalController, private _snackBar: MatSnackBar, 
    private auditTrailService: AuditTrailService, private moderationService: ModerationService) { }

  ngOnInit(): void { 
    
  }

  checkPan() {
    if(this.pan && this.pan.length === 10) {
      this.isSubmitDisabled = true;
      this.moderationService.fetchMlPendingDocuments(this.pan.toUpperCase()).subscribe((data) => {
        if(data.status === 'SUCCESS') {
          this.mlPendingDocuments = data?.docLst?.join(',');
          this.selectedRegId = data.regId;
          // this.getProfileDetails(data.regId);
        }
        else {
          this.errorToast(data.errorMessage);
          this.isSubmitDisabled = false;
          this.selectedRegId = null;
        }
      });
    }
    else {
      this.errorToast("Please enter valid PAN");
      this.isSubmitDisabled = false;
      this.selectedRegId = null;
    }
  }

  async getProfileDetails(regId: number) {
    this.originalResponse = [];
    this.documents = [];
    await this.auditTrailService.getProfileDetailsReport(regId).subscribe((response: any) => {
      if (response != null && !response.error) {
        setTimeout(() => {
          // this.profileDetails = response.pop();

          if (response.length > 0) {
            localStorage.setItem("editRecords", JSON.stringify(response));
            let tempArray = JSON.parse(localStorage.getItem("editRecords"));
            let employeeFlag = false;

            for (let i = 0; i < tempArray.length; i++) {
              this.originalResponse.push({
                qsQuestion: response[i]["qsQuestion"]?.["en"],
                ans_status: response[i]["ans_status"],
                qs_ans_status: response[i]["qs_ans_status"],
                qs_ans: response[i]["qs_ans"],
                qsCode: response[i]["qsCode"],
              });
            }
            for (let i = 0; i < response.length; i++) {
              if (response[i]["qsCode"] == "Q_PAN" && response[i]["qs_ans_status"] == "Rejected-Duplicate") {
                response[i]["qs_ans_status"] = "MHADA Winner with Possession";
              }

              if (response[i]["qsCode"] == "Q_CASTE" && response[i]["qs_ans"] == "OPEN") {
                response[i + 1]["qs_ans_status"] = "Not Applicable";
              }

              if (response[i]["qsCode"] == "Q_DOMICILE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }

              if (response[i]["qsCode"] == "Q_ITR" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              } else if (response[i]["qsCode"] == "Q_ITR_SPOUSE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }

              if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
                // i = 6
                if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans"] == "None") {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                } else {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                }
              } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
                // i= 6
                if (
                  response[i + 3]["qsCode"] == "Q_WORK_STATUS" &&
                  response[i + 3]["qs_ans_status"] != "Not Answered"
                ) {
                  // i = 9
                  if (response[i + 3]["qs_ans"] == "Both") {
                    if (
                      response[i + 4]["qs_ans_status"] == "Verified" ||
                      response[i + 4]["qs_ans_status"] == "Rejected" ||
                      response[i + 5]["qs_ans_status"] == "Verified" ||
                      response[i + 5]["qs_ans_status"] == "Rejected"
                    ) {
                      response[i + 6]["qs_ans_status"] = "Not Applicable";
                    } else if (
                      response[i + 6]["qs_ans_status"] == "Verified" ||
                      response[i + 6]["qs_ans_status"] == "Rejected" ||
                      response[i + 6]["qs_ans_status"] == "Not-Verified"
                    ) {
                      response[i + 4]["qs_ans_status"] = "Not Applicable";
                      response[i + 5]["qs_ans_status"] = "Not Applicable";
                    }
                  } else if (response[i + 3]["qs_ans"] == "Self") {
                    // i = 9
                    response[i + 5]["qs_ans_status"] = "Not Applicable"; // i= 11
                    response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                  } else if (response[i + 3]["qs_ans"] == "Spouse") {
                    // i = 9
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable";
                  } else if (response[i + 3]["qs_ans"] == "None") {
                    response[i + 5]["qs_ans_status"] = "Not Applicable";
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 10
                  }
                }
              }

              if (employeeFlag == false) {
                if (response[i + 2] != undefined) {
                  if (
                    response[i]["qsCode"] == "Q_CENTRAL" &&
                    (response[i]["qs_ans_status"] == "Uploaded" ||
                      response[i]["qs_ans_status"] == "Not-Verified" ||
                      response[i]["qs_ans_status"] == "Verified")
                  ) {
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    response[6]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 1]["qsCode"] == "Q_STATE" &&
                    (response[i + 1]["qs_ans_status"] == "Uploaded" ||
                      response[i + 1]["qs_ans_status"] == "Not-Verified" ||
                      response[i + 1]["qs_ans_status"] == "Verified")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 2]["qsCode"] == "Q_MHADA" &&
                    (response[i + 2]["qs_ans_status"] == "Verified" || response[i + 2]["qs_ans_status"] == "Rejected")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  }
                }
              }

              if (
                (response[i]["qs_ans"] == "No" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None of the above" && response[i]["qs_ans_status"] == "Answered")
              ) {
                if (response[i]["qsCode"] == "Q_CAST_VALID") {
                  response[i]["qs_ans_status"] = "Allowed with Condition";
                } else {
                  response[i]["qs_ans_status"] = "Not Applicable";
                  response[i]["qs_ans"] = "";
                }
              } else if (response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }

              this.documents.push({
                qsQuestion: response[i]["qsQuestion"]?.["en"],
                ans_status: response[i]["ans_status"],
                qs_ans_status: response[i]["qs_ans_status"],
                qs_ans: response[i]["qs_ans"],
              });
            }

            for (let i = 0; i < this.documents.length; i++) {
              if (
                this.documents[i]["qs_ans_status"] != null &&
                this.documents[i]["qs_ans_status"].toLowerCase().includes("rejected")
              ) {
                // this.manualRejectedQuestions.push(this.documents[i]);
              } else if (
                this.documents[i]["qs_ans_status"] == null ||
                this.documents[i]["qs_ans_status"].startsWith("Rejected") ||
                this.documents[i]["qs_ans_status"] == "Not Answered" ||
                this.documents[i]["qs_ans_status"] == "Pending for Moderator Check" ||
                this.documents[i]["qs_ans_status"] == "Verification in Progress" ||
                this.documents[i]["qs_ans_status"] == "MHADA Winner with Possession"
              ) {
              }
            }
            
          } else {
            this.warningToast();
          }
          console.log('submit ', false);
          this.isSubmitDisabled = false;
        }, 500);
      } else {
        this.errorToast("Oops, something went wrong, please try after sometime.");
        this.isSubmitDisabled = false;
      }
    });
  }

  onCancel() {
    return this.modalCtrl.dismiss(null, 'close');
  }

  async warningToast() {
    await this._snackBar.open("No data available for the entered regId.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

}
